//
//
//
//
//
export default {
  name: "index",
  data: function data() {
    return {};
  },
  created: function created() {
    //解析传过来的html字符串，渲染页面，提交表单
    var div = document.createElement('div');
    console.log(this.$route.query.htmls);
    div.innerHTML = this.$route.query.htmls;
    document.body.appendChild(div);
    document.forms[0].submit();
  }
};